import { useTranslation } from "react-i18next";
import { Company } from "../lib/models";
import Button from "./buttons/Button";
import CompanyLogo from "./CompanyLogo";
import { HeroImage } from "./HeroImage";

const Hero: React.FC<{
  company: Company | null;
  image: { src: string; alt: string; effect?: boolean } | null;
  onButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({ company, image, onButtonClick }) => {
  const { t } = useTranslation(["HomeView"]);
  return (
    <div className="relative overflow-hidden isolate text-primary px-4 sm:py-4 lg:px-8 max-w-4xl mx-auto">
      <div className="flex flex-row justify-between items-center py-4">
        <CompanyLogo company={company} />
        <div>
          <Button onClick={onButtonClick} text={t("HomeView:jobOpenings")} />
        </div>
      </div>

      <HeroImage
        src={image?.src || ""}
        alt={image?.alt || ""}
        wEffects={image?.effect || false}
      />
    </div>
  );
};

export default Hero;
